import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BbbRoom, SidekickServerConf } from '@reflact/kick';
import { LicenseService } from 'src/app/license-management/license.service';

@Component({
  selector: 'app-forced-server-editor',
  standalone: false,
  templateUrl: './forced-server-editor.component.html',
})
export class ForcedServerEditorComponent implements OnInit {
  @Input() public room: BbbRoom;
  @Output() public updateRoom: EventEmitter<BbbRoom> = new EventEmitter();
  public console = console;
  public servers: SidekickServerConf[] = [];
  protected serverIdExpDate: string = '';

  constructor(private licenseService: LicenseService) { }

  public async ngOnInit(): Promise<void> {
    this.servers = (await this.licenseService.getKickServers()).filter(server => server.enabled && server.manualSelect);
    if (this.room.serverIdExpDate) {
      this.serverIdExpDate = new Date(this.room.serverIdExpDate).toISOString().split('T')[0];
    }
  }

  protected onDateChange(value: string) {
    this.room.serverIdExpDate = new Date(value);
    this.updateRoom.emit(this.room);
  }
}
